'use client';

import { motion } from 'framer-motion';
import TrailingLink from '@/components/atoms/TrailingLink';
import styles from './CategoryGrid.module.scss';

export interface CategoryGridItem {
  id: string;
  title: string;
  description: string;
  href: string;
  icon: string;
  highlights?: string[];
}

interface CategoryGridProps {
  categories: CategoryGridItem[];
  className?: string;
}

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut' as const,
    },
  },
};

export function CategoryGrid({ categories, className }: CategoryGridProps) {
  return (
    <motion.div
      className={`${styles.categoryGrid} ${className || ''}`}
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      {categories.map((category) => (
        <motion.div
          key={category.id}
          variants={itemVariants}
        >
          <TrailingLink href={category.href} className={styles.categoryCard}>
            <div className={styles.categoryIcon}>{category.icon}</div>
            <h3 className={styles.categoryTitle}>{category.title}</h3>
            <p className={styles.categoryDescription}>
              {category.description}
            </p>
            {category.highlights && (
              <ul className={styles.highlightsList}>
                {category.highlights.map((highlight, index) => (
                  <li key={index}>{highlight}</li>
                ))}
              </ul>
            )}
            <span className={styles.categoryArrow}>→</span>
          </TrailingLink>
        </motion.div>
      ))}
    </motion.div>
  );
}

export default CategoryGrid;